<template>
  <div id="restaurant-website">
    <Preloader></Preloader>
    <mobile-menu :menu="menu" v-if="menu"/>
    <navigation-bar v-if="this.$store.state.isConfigReady && menu" :menu="menu"/>

    <router-view></router-view>

    <!-- Footer Start -->
    <bottom-bar v-if="this.$store.state.isConfigReady && menu" :menu="menu"/>
  </div>
</template>

<script>
import Preloader from "./components/Preloader";
import router from "@/router";
import menuComponentResolver from "@/helpers/menuComponentResolver";
import NavigationBar from "@/views/NavigationBar";
import MobileMenu from "@/views/NavigationBar/MobileMenu";
import {mapMutations} from "vuex";
import BottomBar from "@/views/BottomBar";
import VueRouter from "vue-router";
import config from "@/data/config.json"
import websiteMenu from "@/data/website-menu.json"

window.apiUrl = process.env.VUE_APP_API_URL;
window.mediaUrl = process.env.VUE_APP_MEDIA_URL;

export default {
  title() {
    return this.config.name
  },
  name: 'app',
  data() {
    return {
      menu: [],
      config: window.config
    }
  },
  watch: {
    '$route'(to) {
      this.updateWebsiteMetadata(
          {
            title: to.meta.title
          }
      );
    }
  },
  beforeMount() {
    // axiosHelper.axios.get(window.apiUrl + '/api/config')
    //     .then((response) => {
          window.config = config;
          this.configReady();
        // });
    // axiosHelper.axios.get(window.apiUrl + '/api/website-menu')
    //     .then((response) => {
          let routesData = websiteMenu;
          let routes = [];
          this.resetRouter();
          routesData.forEach((route) => {
            let newRoute = {
              path: route.url,
              component: menuComponentResolver.resolve(route.url),
              name: route.id,
              meta: {
                auth: false,
                title: route.title
              },
              props: {
                components: route.components
              }
            };
            routes.push(newRoute);
          });
          router.addRoutes(routes)
          this.menu = routesData;
        // });
  },
  methods: {
    ...mapMutations({
      configReady: "configReady"
    }),
    updateWebsiteMetadata(metadata = {}) {
      Object.keys(metadata).forEach(key => {
        document[key] = metadata[key];
      });
    },
    resetRouter() {
      const newRouter = new VueRouter({mode: 'history'})
      router.matcher = newRouter.matcher // reset router
      router.options.routes = []
    }
  },
  components: {
    BottomBar,
    MobileMenu,
    NavigationBar,
    Preloader
  }
}
</script>


<style>
@import "assets/css/plugins/bootstrap.min.css";
@import "assets/css/style.css";
</style>
